import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const ManagementTiersPopup = ({
  open,
  onClose,
  managementFeesTier,
  setmanagementFeesTier,
}) => {
  const [editPopupOpen, setEditPopupOpen] = useState(false);
  const [editRow, setEditRow] = useState(null);

  const handleEditClick = (row) => {
    setEditRow(row);
    setEditPopupOpen(true);
  };

  const handleEditClose = () => {
    setEditRow(null);
    setEditPopupOpen(false);
  };

  const handleAddRow = () => {
    const newRow = {
      id: managementFeesTier?.length + 1,
      range: { min: "", max: "" },
      percentage: "",
    };
    setmanagementFeesTier((prevRows) => [...prevRows, newRow]);
  };

  const handleRowChange = (id, field, value) => {
    setmanagementFeesTier((prevRows) =>
      prevRows.map((row) =>
        row.id === id
          ? {
              ...row,
              [field]: value, // Update range or percentage fields
            }
          : row
      )
    );
  };

  const handleRangeChange = (id, rangeField, value) => {
    setmanagementFeesTier((prevRows) =>
      prevRows.map((row) =>
        row.id === id
          ? {
              ...row,
              range: {
                ...row.range,
                [rangeField]: value,
              },
            }
          : row
      )
    );
  };

  const handleDeleteRow = (id) => {
    setmanagementFeesTier((prevRows) => prevRows.filter((row) => row.id !== id));
  };

  const handleSaveRecord = () => {
    // Check if all fields are empty
    const allEmpty = managementFeesTier.every(
      (row) => row.percentage === "" && row.range.min === "" && row.range.max === ""
    );

    if (allEmpty) {
      // If all fields are empty, set managementFeesTier to an empty array
      setmanagementFeesTier([]);

    }

    // Optionally, you can close the dialog after saving
    onClose();
  };

  return (
    <div>
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>Management Tiers</DialogTitle>
        <DialogContent>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Serial No</TableCell>
                <TableCell>Range (Min - Max)</TableCell>
                <TableCell>Percentage</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {managementFeesTier?.map((row, index) => (
                <TableRow key={row.id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>
                    <TextField
                      type="number"
                      value={row.range.min}
                      onChange={(e) =>
                        handleRangeChange(row.id, "min", e.target.value)
                      }
                      inputProps={{
                        style: {
                          width: 50,
                          padding: "5px", // Reduce padding for compact size
                          fontSize: "12px", // Smaller font
                        },
                      }}
                    />
                    {" - "}
                    <TextField
                      type="number"
                      value={row.range.max}
                      onChange={(e) =>
                        handleRangeChange(row.id, "max", e.target.value)
                      }
                      inputProps={{
                        style: {
                          width: 50,
                          padding: "5px",
                          fontSize: "12px",
                        },
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      type="number"
                      value={row.percentage}
                      onChange={(e) =>
                        handleRowChange(row.id, "percentage", e.target.value)
                      }
                      inputProps={{
                        style: {
                          width: 50,
                          padding: "5px",
                          fontSize: "12px",
                        },
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    <IconButton
                      onClick={() => handleDeleteRow(row.id)} // Call delete function
                      size="small"
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}>
            <Button onClick={handleAddRow} size="small" style={{ border: "1px solid" }}>
              Add New Row
            </Button>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSaveRecord} variant="contained" size="small">
            Save Record
          </Button>
          <Button onClick={onClose} size="small">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Popup */}
      {editRow && (
        <Dialog open={editPopupOpen} onClose={handleEditClose}>
          <DialogTitle>Edit Row</DialogTitle>
          <DialogContent>
            <TextField
              label="Min Range"
              type="number"
              fullWidth
              margin="normal"
              value={editRow.range.min}
              onChange={(e) =>
                setEditRow((prev) => ({
                  ...prev,
                  range: { ...prev.range, min: Number(e.target.value) },
                }))
              }
            />
            <TextField
              label="Max Range"
              type="number"
              fullWidth
              margin="normal"
              value={editRow.range.max}
              onChange={(e) =>
                setEditRow((prev) => ({
                  ...prev,
                  range: { ...prev.range, max: Number(e.target.value) },
                }))
              }
            />
            <TextField
              label="Percentage"
              type="number"
              fullWidth
              margin="normal"
              value={editRow.percentage}
              onChange={(e) =>
                setEditRow((prev) => ({
                  ...prev,
                  percentage: Number(e.target.value),
                }))
              }
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleEditClose}>Cancel</Button>
            <Button onClick={handleEditClose} variant="contained">
              Save
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
};

export default ManagementTiersPopup;
